import React from 'react';
import stickImg from './img/sticker2-white-x2.png';

import './Sticker.scss';

type Props = {
    rotate?: number;
};

const Sticker: React.FC<Props> = ({rotate}) => {
    
    return (
        <div className='sticker'>
            
        </div>
    );
};

export default Sticker;